// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f900305b","455":"f47fe8d4","488":"7e7b2fb3"}[chunkId] + ".chunk.js";
};